import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/categories/homes.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/igloo.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/search/filters/instant.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/spaces/basketball-court.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/spaces/large-backyard.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/spaces/pickleball.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/spaces/pool.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/spaces/tennis-court.svg");
;
import(/* webpackMode: "eager" */ "/app/src/page/home/hero-poster-server.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/layout/colors/background-colors.css.ts");
;
import(/* webpackMode: "eager", webpackExports: ["Home"] */ "/app/src/page/home/home.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/services/datadog/datadog-logs.ts");
